import { Icons } from '@agro-club/agroclub-shared'
import { FC, useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { DispatchingModal } from './DispatchingModal/DispatchingModal'

interface Props {
  id: string
  permissions: string[]
  onSuccess: () => void
  currentDates: string[]
}

export const EditInfoCell: FC<Props> = ({ id, permissions, onSuccess, currentDates }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <>
      <AButton
        id="edit"
        color="secondary"
        Icon={Icons.IconEdit}
        size="small"
        onClick={() => setIsModalOpen(true)}
        disabled={!permissions.includes('deals.change_dealdispatching')}
      />

      {isModalOpen && (
        <DispatchingModal
          onClose={() => setIsModalOpen(false)}
          id={id}
          currentDates={currentDates}
          onSuccess={onSuccess}
        />
      )}
    </>
  )
}
